var _circle, _path, _path2, _circle2, _path3, _path4, _path5, _ellipse, _ellipse2, _circle3, _g, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyOderedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 150,
    viewBox: "0 0 154 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 62,
    r: 56,
    fill: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    },
    clipPath: "url(#clip0_2512_4857)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8828 106.917C45.3141 113.009 42.2121 118.392 41.9906 118.895C41.6584 119.65 41.6151 120.045 41.7198 121.363C41.8275 122.718 41.9298 123.064 42.4201 123.829C43.6573 125.766 45.5074 126.721 47.7346 126.544C49.3507 126.434 50.5714 125.814 51.5608 124.634C51.9352 124.174 55.1702 118.818 58.7403 112.745L65.2378 101.676L60.8905 99.1456C58.5194 97.7465 56.3413 96.4255 56.0437 96.2064C55.7647 95.9858 55.5072 95.8008 55.4516 95.8052C55.4159 95.8267 52.4499 100.806 48.8828 106.917Z",
    fill: "#4A66A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1376 91.5576C56.6061 90.7595 57.6328 90.4923 58.4309 90.9608L68.872 97.0899C69.6701 97.5583 69.9373 98.5851 69.4688 99.3832L67.4332 102.851C66.3791 104.647 64.069 105.248 62.2733 104.194L55.4447 100.185C53.6491 99.1312 53.0479 96.821 54.102 95.0253L56.1376 91.5576Z",
    fill: "#FFCE71"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.6709,
    cy: 73.2164,
    r: 22.6905,
    fill: "#C7C4EA",
    stroke: "#4A66A0",
    strokeWidth: 5.58535
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7552 69.537C56.5545 69.7879 56.4039 70.1058 56.4039 70.2731C56.4039 70.842 57.1735 71.6785 58.2443 72.2641C59.2147 72.7995 59.4657 72.8665 60.5867 72.8665C62.0757 72.8665 63.1633 72.4482 64.1504 71.4778C65.6897 69.972 64.2006 68.2654 62.5107 69.6039C61.2392 70.6077 60.1015 70.6077 58.8132 69.5871C58.0101 68.9514 57.2404 68.9346 56.7552 69.537Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1918 69.3696C78.5727 69.8047 78.6898 70.7416 79.4595 71.4778C80.3964 72.4147 81.5341 72.8497 82.9228 72.8665C84.1944 72.8665 84.8636 72.649 85.9679 71.9128C86.8044 71.3607 87.2562 70.591 87.0889 70.0556C86.771 68.9848 85.7838 68.8008 84.78 69.5871C83.4917 70.6077 82.354 70.6077 81.0824 69.6039C80.3797 69.0518 79.7606 68.9681 79.1918 69.3696Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3575 72.5987C68.8182 73.0003 66.5595 74.6901 66.1078 75.8111C65.8233 76.4803 66.1412 77.2165 66.7938 77.4507C67.463 77.685 67.9147 77.4842 68.584 76.6476C68.8851 76.2796 69.4875 75.7609 69.9225 75.5099C71.5621 74.5395 73.7037 75.0247 75.0087 76.6476C75.678 77.4842 76.1297 77.685 76.799 77.4507C77.4515 77.2165 77.7694 76.4803 77.485 75.8111C77.1671 75.0415 75.427 73.4855 74.3562 73.017C73.3189 72.5485 71.3279 72.3477 70.3575 72.5987Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5986,
    cy: 75.451,
    rx: 3.63618,
    ry: 2.02469,
    fill: "#FFB0BA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.4981,
    cy: 76.2886,
    rx: 3.63618,
    ry: 2.02469,
    fill: "#FFB0BA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2512_4857",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 47,
    width: 52,
    height: 52
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.7409,
    cy: 73.2166,
    r: 25.2737,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2512_4857)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.219,
    cy: 73.2836,
    r: 55.4413,
    fill: "#D9D9D9"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.843 47.8744C125.843 45.131 124.938 42.4643 123.268 40.2878C121.598 38.1114 119.256 36.5468 116.606 35.8367C113.956 35.1267 111.146 35.3109 108.611 36.3608C106.077 37.4106 103.959 39.2674 102.588 41.6433C102.116 42.4613 101.989 43.433 102.233 44.345C102.478 45.2569 103.075 46.0343 103.892 46.5063C104.71 46.9783 105.682 47.1063 106.594 46.8621C107.506 46.6179 108.284 46.0214 108.756 45.204C109.226 44.3928 109.9 43.7191 110.712 43.2505C111.523 42.7818 112.444 42.5345 113.381 42.5335C114.797 42.5335 116.156 43.0962 117.158 44.0978C118.159 45.0994 118.722 46.4579 118.722 47.8744C118.722 49.291 118.159 50.6495 117.158 51.6511C116.156 52.6527 114.797 53.2154 113.381 53.2154H113.372C113.143 53.2383 112.918 53.2845 112.698 53.3532C112.458 53.3782 112.221 53.4266 111.991 53.498C111.795 53.6045 111.61 53.7295 111.437 53.8713C111.233 53.9826 111.04 54.1134 110.86 54.2621C110.7 54.4532 110.561 54.6605 110.444 54.8806C110.314 55.0412 110.199 55.2129 110.099 55.3939C110.022 55.6393 109.971 55.8923 109.947 56.1485C109.885 56.3532 109.842 56.5634 109.82 56.7761V60.3368L109.828 60.3772L109.832 62.1258C109.835 63.0686 110.211 63.9719 110.879 64.6378C111.546 65.3036 112.45 65.6776 113.393 65.6778H113.402C114.346 65.6754 115.251 65.298 115.917 64.6287C116.583 63.9593 116.956 63.0527 116.954 62.1084L116.948 59.7535C119.51 58.9918 121.759 57.4252 123.361 55.2856C124.963 53.146 125.834 50.5473 125.843 47.8744ZM110.879 72.0513C110.379 72.5472 110.037 73.1801 109.897 73.8701C109.757 74.5601 109.824 75.2762 110.091 75.9279C110.358 76.5796 110.811 77.1376 111.395 77.5313C111.979 77.9251 112.666 78.1369 113.37 78.1401C114.315 78.1324 115.22 77.7628 115.9 77.1075C116.561 76.432 116.931 75.5246 116.931 74.5796C116.931 73.6345 116.561 72.7271 115.9 72.0516C115.218 71.4164 114.321 71.0631 113.39 71.0631C112.458 71.063 111.561 71.4162 110.879 72.0513Z",
    fill: "#4A66A0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 137.573C58.5833 137.573 70 135.206 70 132.287C70 129.367 58.5833 127 44.5 127C30.4167 127 19 129.367 19 132.287C19 135.206 30.4167 137.573 44.5 137.573Z",
    fill: "#F1F1F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2512_4857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.941,
    height: 113.941,
    fill: "white",
    transform: "translate(12 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOderedIcon);
export default __webpack_public_path__ + "static/media/empty-odered-icon.eeab245fd987654bc865bfc4dfe27a1c.svg";
export { ForwardRef as ReactComponent };